<template>
  <i :class="['bf-icon', `icon-${size}`, `icon-${name}`, $attrs.class]" class="cursor-pointer" v-on="$listeners" />
</template>

<script>
export default {
  name: 'cloud-icon',
  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    size: {
      type: String,
      default: 'm',
    },
  },
  computed: {
  },
}
</script>